import styled from 'styled-components';
import { CurrencyIconProps } from './types';

const Icon = styled.img<Omit<CurrencyIconProps, 'currency'>>`
  height: ${({ size }) => size}px;
  margin: ${({ margin }) => margin};
  width: ${({ size }) => size}px;
`;

export default Icon;
